export function buildThreadId(videoId, instructorId, studentId) {
  if (!videoId || !instructorId || !studentId) {
    return null;
  }

  return `${videoId}_${instructorId}_${studentId}`;
}

// Pass 75 (§14) — the ONE canonical messaging target is the canonical Inbox's Messages tab. Legacy
// `/notifications` / `/messages` routes redirect here, preserving the `thread` deep-link.
export function getThreadNavigationTarget(threadId) {
  if (!threadId) {
    return '/inbox?tab=messages';
  }

  return `/inbox?tab=messages&thread=${encodeURIComponent(threadId)}`;
}
